import React, { useState, useEffect } from 'react';
import CastUpsert from './CastUpsert';
import MemberListing from './MemberListing';
import LoadCastFile from '../UploadCast';

export default function CastLanding(subEntity: any) {

    let [CastCount, SetCastCount] = useState(1);
    let [loadCast, SetloadCast] = useState(false);
    let [MemberOpen, SetMemberOpen] = useState(false);
    let [CastsUpsert, SetCastsUpsert] = useState(false);
    let [yearOption, SetYearOption] = useState<any>([]);
    let [MemberSelected, SetMemberSelected] = useState<any>([]);

    const CastsUpsertChange = (e: any) => {
        CastsUpsert = false
        SetCastsUpsert(CastsUpsert)
    }

    const LoadCastFileChange = (e: any) => {
        console.log(loadCast)
        loadCast = false
        SetloadCast(loadCast)
    }

  const castLists = [
    {
        id: "PRD-10442",
        displayName: "Cast List v1 (Initial Upload)",
        productionId: "PRD-10442",
        productionName: "The River's Edge",
        programmeNo: "BBC-EP-03",
        castType: "Episode",
        status: "active",
        becsMembers: {
            verified: 42,
            total: 57,
        },
        totalUpdated: "2026-02-04",
    },
    {
        id: "PRD-11587",
        displayName: "Cast List - National Heroes",
        productionId: "PRD-11567",
        productionName: "National Heroes",
        programmeNo: "Pilot",
        castType: "Main",
        status: "active",
        becsMembers: {
            verified: 29,
            total: 33,
        },
        totalUpdated: "2026-01-23",
    },
    {
        id: "PRD-12098",
        displayName: "Cast List - My Fair Lady (U)",
        productionId: "PRD-12098",
        productionName: "My Fair Lady",
        programmeNo: "Full",
        castType: "Full",
        status: "submitted",
        becsMembers: {
            verified: 45,
            total: 48,
        },
        totalUpdated: "2025-09-11",
    },
    {
        id: "PRD-10721",
        displayName: "Holiday Special Cast",
        productionId: "PRD-10721",
        productionName: "The Comedy Hour",
        programmeNo: "Holiday Special",
        castType: "Full",
        status: "draft",
        becsMembers: {
            verified: 0,
            total: 14,
        },
        totalUpdated: "2024-12-20",
    },
    {
        id: "PRD-14152",
        displayName: "Season 4 Cast Overview",
        productionId: "PRD-14152",
        productionName: "Crime Files",
        programmeNo: "Full",
        castType: "Full",
        status: "closed",
        becsMembers: {
            verified: 72,
            total: 78,
        },
        totalUpdated: "2024-10-15",
    },
    {
        id: "PRD-14152-UPDATE",
        displayName: "Season 4 cast update",
        productionId: "PRD-14152",
        productionName: "Crime Files",
        programmeNo: "Full",
        castType: "Full",
        status: "closed",
        becsMembers: {
            verified: 72,
            total: 78,
        },
        totalUpdated: "2024-10-15",
    },
];


    useEffect(() => {
        const startYear = 1990;
        const currentYear = new Date().getFullYear();

        const years = Array.from(
            { length: currentYear - startYear + 1 },
            (_, i) => currentYear - i
        );

        yearOption = years;
        SetYearOption(yearOption)
    }, [])

    const SelectMemberListing = (cast: any) => {
        console.log(cast)
        MemberSelected = cast
        SetMemberSelected(MemberSelected)
        MemberOpen = true;
        SetMemberOpen(MemberOpen)
    }

    const MemberListingChange = (e: any) => {
        MemberOpen = false;
        SetMemberOpen(MemberOpen)
    }

    const openImport = () => {
        loadCast = true;
        SetloadCast(loadCast)
        console.log(loadCast)
    }

    let [searchFor, SetSearch] = useState("");
    let [yearSelection, SetyearSelection] = useState("");
    let [statusSelection, SetStatusSelection] = useState("");
    let [ProducerSelection, SetProducerSelection] = useState("");

    const clearFilter = () => {
        searchFor = '';
        SetSearch(searchFor)

        yearSelection = '';
        SetyearSelection(yearSelection)

        statusSelection = '';
        SetStatusSelection(statusSelection)

        ProducerSelection = '';
        SetProducerSelection(ProducerSelection)
    }

    
    let [CueSelected, SetCueSelected] = useState<any>([]);

    return (<>

        <div className="ws-12 prl">

            <div className='ws-12 box mbl'>
                <div className='ws-12 pm'>
                    <div className='w-71'>
                        <div className='ws-6 box ps height40'>
                            <input type="text" className="ws-12 pull-right height30" value={searchFor} onChange={(e) => SetSearch(e.target.value)}
                                placeholder='Search by Production title,ID,Programme Number' style={{ border: 'none', outline: 'none' }} />
                        </div>

                        <select className='ml pm pbl height40 grey text-bold icon-btn info' value={statusSelection} onChange={(e: any) => SetStatusSelection(e.target.value)}>
                            <option value={'All'}> All Statuses</option>
                            <option value={'Draft'}> Draft </option>
                            <option value={'Active'}> Active </option>
                            <option value={'Closed'}> Closed  </option>
                            <option value={'Archived'}> Archived  </option>
                        </select>

                        <select className='ml pm pbl height40 width110 grey text-bold center icon-btn info' value={yearSelection} onChange={(e: any) => SetyearSelection(e.target.value)}>
                            <option> All Years</option>
                            {
                                yearOption?.map((vales: any) => {
                                    return (<option value={vales}> {vales}  </option>)
                                })
                            }
                        </select>

                        <select className='ml pm pbl height40 width80 grey text-bold icon-btn info hide' title='Broadcaster/Producer' value={ProducerSelection} onChange={(e: any) => SetProducerSelection(e.target.value)}>
                            <option> All</option>
                        </select>

                        <select className='pm pbl height40 width90 white text-bold icon-btn info hide'  >
                            <option> Filter </option>
                        </select>
                    </div>
                    {(searchFor.length > 0 || statusSelection.length > 0 || ProducerSelection.length > 0 || yearSelection.length > 0) &&
                        <button type="button" className="text-bold icon-btn delete height40 mr pull-left width70" onClick={clearFilter}>Clear</button>}
                    <button type="button" className="text-bold icon-btn edit pull-right height40" onClick={() => SetCastsUpsert(true)}>New Cast List</button>
                    <button type="button" className="text-bold icon-btn info pull-right height40" >Export</button>
                    <button type="button" className="text-bold icon-btn borderNone noOutline height40 mr pull-right" onClick={() => openImport()}>Import <i className='icon-angle-right pll text-l'></i></button>

                </div>
            </div>


            {(searchFor.length > 0 || statusSelection.length > 0 || ProducerSelection.length > 0 || yearSelection.length > 0) && <div className='ws-12 pm'>

                <div className='ws-12 box landing pm text-center'>
                    {searchFor.length > 0 && <>
                        <span className='text-bold mr'>Search : </span>
                        <span className='mr'>{searchFor} </span>
                    </>}

                    {statusSelection.length > 0 && <>
                        <span className='text-bold mr'>Status :</span>
                        <span className='mr'>{statusSelection}</span>
                    </>}

                    {ProducerSelection.length > 0 && <>
                        <span className='text-bold mr'>Producer/Broadcast :</span>
                        <span className='mr'>{ProducerSelection}</span>
                    </>}
                    {yearSelection.length > 0 && <>
                        <span className='text-bold mr'>Year :</span>
                        <span className='mr'>{yearSelection}</span>
                    </>}
                </div>

            </div>}

            <div className='ws-12  hide'>

                <table className="newTable box">
                    <thead>
                        <tr>
                            <th style={{ width: "10px" }}><input type='checkbox'></input></th>
                            <th >Cast Title</th>
                            <th >Cast ID</th>
                            <th >Programme No</th>
                            <th >Members</th>
                            <th >Status</th>
                            <th >Total Updated</th>
                            <th >Operations</th>
                        </tr>
                    </thead>
                    <tbody>

                        {castLists.map((row: any) => (
                            <tr>
                                <td> <input type='checkbox'></input></td>
                                <td>
                                    <h2 className='ws-12 primary'>{row.displayName}</h2>
                                </td>
                                <td>
                                    <h3 className='ws-12'>{row.id} </h3>
                                </td>
                                <td>{row.programmeNo}</td>
                                <td>{row.castType}</td>
                                <td>

                                    {(row.status == "active") && <div className='width150 height30'>
                                        <div className='bg-level7 ps text-center borderRadius-s height30'>
                                            <span className='white '><i className='white pll pt icon-tick1'></i>{row.status}</span>
                                        </div>
                                    </div>}


                                    {(row.status == "submitted") && <div className='width150 height30'>
                                        <div className='bg-level15 ps text-center borderRadius-s height30'>
                                            <span className='white '><i className='white pll pt icon-paragraph-justify'></i>{row.status}</span>
                                        </div>
                                    </div>}


                                    {(row.status == "draft") && <div className='width150'>
                                        <div className='bg-level2 ps text-center borderRadius-s height30'>
                                            <span className='purple '><i className='purple pll pt icon-filled-circle'></i>{row.status}</span>
                                        </div>
                                    </div>}

                                    {(row.status == "closed") && <div className='width150 height30'>
                                        <div className='bg-level2 ps text-center borderRadius-s height30'>
                                            <span className='purple '><i className='purple pll pt icon-filled-circle'></i>{row.status}</span>
                                        </div>
                                    </div>}
                                </td>
                                <td>{row.totalUpdated}</td>
                                <td> <span className='text-l text-bold'>...</span> </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {(CastCount == 0 && (castLists.length == 0)) && <div className='ws-12 box text-center'>

                    <div style={{ paddingTop: "100px", paddingBottom: "100px" }}>

                        <img alt="Korrect" 
                            src="https://cdn-icons-png.flaticon.com/512/1179/1179120.png" 
                            className="empty-icon"
                        />

                        <h1 className='text-bold'>No Casts yet</h1>
                        <h3 className='text-bold grey'>Create your first Cast to begin recording casts and cues.</h3>

                        <div className=' ptxl paddingCenterBox'>
                            <button type="button" className=" icon-btn primary white text-bold bg-level5 paddingCenterBox height40 mr" onClick={() => SetCastsUpsert(true)}>New Cast</button>
                        </div>
                    </div>


                </div>}

            </div>

            <div className='ws-12 '>

                {(CastCount > 0 && (castLists.length > 0)) && <table className="newTable box">
                    <thead>
                        <tr>
                            <th className='forceSingleLine'>Cast List Name</th>
                            <th className='forceSingleLine'>Production</th>
                            <th className='forceSingleLine'>Programme No</th>
                            <th className='forceSingleLine'>Cast Type</th>
                            <th className='forceSingleLine'>Cast Status</th>
                            <th className='forceSingleLine'>Members</th>
                            <th className='forceSingleLine'> Total Performers </th>
                            <th className='forceSingleLine'>Total Updated</th>
                            <th ></th>
                        </tr>
                    </thead>
                    <tbody>

                        {castLists.map((row: any) => (
                            <tr>
                                <td>
                                    <div className='ws-12'>
                                        <h2 className='ws-12 primary'>{row.displayName}</h2>
                                        <h3 className='ws-12'>{row.id} </h3>
                                    </div>

                                </td>
                                <td>
                                    <div className='ws-12'>
                                        <h2 className='ws-12 primary'>{row.productionName}</h2>
                                        <h3 className='ws-12'>{row.productionId}</h3>
                                    </div>
                                </td>
                                <td>{row.programmeNo}</td>
                                <td>{row.castType}</td>
                                <td>

                                    {(row.status == "active") && <div className='width150 height30'>
                                        <div className='bg-level7 ps text-center borderRadius-s height30'>
                                            <span className='white '><i className='white pll pt icon-tick1'></i>{row.status}</span>
                                        </div>
                                    </div>}


                                    {(row.status == "submitted") && <div className='width150 height30'>
                                        <div className='bg-level15 ps text-center borderRadius-s height30'>
                                            <span className='white '><i className='white pll pt icon-paragraph-justify'></i>{row.status}</span>
                                        </div>
                                    </div>}


                                    {(row.status == "draft") && <div className='width150'>
                                        <div className='bg-level2 ps text-center borderRadius-s height30'>
                                            <span className='purple '><i className='purple pll pt icon-filled-circle'></i>{row.status}</span>
                                        </div>
                                    </div>}


                                    {(row.status == "closed") && <div className='width150 height30'>
                                        <div className='bg-level2 ps text-center borderRadius-s height30'>
                                            <span className='purple '><i className='purple pll pt icon-filled-circle'></i>{row.status}</span>
                                        </div>
                                    </div>}
                                </td>
                                <td><span onClick={() => SelectMemberListing(row)}> {row.becsMembers.verified}</span> / {row.becsMembers.total}</td>
                                <td>{row.becsMembers.total}</td>
                                <td>{row.totalUpdated}</td>
                                <td>
                                    <div className=" hover-box text-center ">
                                        <div className="hover-box   text-l text-bold"> ... </div>

                                        <ul className="hover-block rightReset ws-3 pull-right plxl bgTransparent">
                                            <li className='pt ws-10 pull-right'> <button className="pull-left icon-btn info width190">View</button> </li>
                                            <li className='pt ws-10 pull-right'><button className="pull-left icon-btn edit width190" onClick={() => {SetCastsUpsert(true); SetCueSelected(row)}}>Edit</button></li>
                                            <li className='pt ws-10 pull-right'><button className="pull-left icon-btn info width190">Load Cast File</button></li>
                                            <li className='pt ws-10 pull-right'> <button className="pull-left icon-btn info width190">Submit</button></li>
                                            <li className='pt ws-10 pull-right'> <button className="pull-left icon-btn info width190">Archive</button> </li>
                                        </ul>

                                    </div>
                                </td>
                                <td className='hide'> <i className='purple pll pt icon-arrow-point-to-right-2 '></i></td>
                            </tr>
                        ))}
                    </tbody>
                </table>}

                {(CastCount == 0 && (castLists.length == 0)) && <div className='ws-12 box text-center'>

                    <div style={{ paddingTop: "100px", paddingBottom: "100px" }}>

                        <img alt="Korrect" 
                            src="https://cdn-icons-png.flaticon.com/512/1179/1179120.png" 
                            className="empty-icon"
                        />

                        <h1 className='text-bold'>No Casts yet</h1>
                        <h3 className='text-bold grey'>Create your first Cast to begin recording casts and cues.</h3>

                        <div className=' ptxl paddingCenterBox'>
                            <button type="button" className=" icon-btn primary white text-bold bg-level5 paddingCenterBox height40 mr" onClick={() => SetCastsUpsert(true)}>New Cast</button>
                        </div>
                    </div>


                </div>}

            </div>

            {
                (() => {
                    if (CastsUpsert) {
                        return <CastUpsert CastsUpsertChange={CastsUpsertChange} CastUpsertOpen={CastsUpsert} CueSelected={CueSelected}/>
                    }

                    if (MemberOpen) {
                        return <MemberListing MemberListingChange={MemberListingChange} MemberListingOpen={MemberOpen} MemberSelected={MemberSelected} />
                    }

                    if (loadCast == true) {
                        return <LoadCastFile LoadCastFileChange={LoadCastFileChange} loadCast={loadCast} />
                    }

                })()
            }
        </div>
    </>)
}